import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';  // Assuming AuthContext provides user and token
import ApiStatusOverview from '../components/ApiStatusOverview';  // Make sure this import is correct
import DataDisplay from '../components/DataDisplay';  // To display specific API data
import CalendarStatus from '../components/CalendarStatus';  // New component for calendar status
import UserManagement from '../components/UserManagement';
import GamesDataBrowser from '../components/admin/GamesDataBrowser';
import WatchDataPanel from '../components/admin/WatchDataPanel';
import AdminLockManager from '../components/admin/AdminLockManager';
import AdminManualLockCreator from '../components/admin/AdminManualLockCreator';
import styles from '../styles/AdminDashboard.module.css';
import VersionFooter from '../components/VersionFooter';

function AdminDashboard() {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('users');
  const [error] = useState('');

  if (!user || user.role !== 'admin') {
    return <div className={styles.errorMessage}>You do not have permission to access this page.</div>;
  }

  const renderComponent = () => {
    switch (activeTab) {
      case 'users':
        return <UserManagement />;
      case 'apiStatus':
        return <ApiStatusOverview />;  // Make sure this line is correct
      case 'locks':
        return <AdminLockManager />;
      case 'createLock':
        return <AdminManualLockCreator />;
      case 'games':
        return <GamesDataBrowser />;
      case 'venues':
        return <DataDisplay apiEndpoint="/admin/venues" />;
      case 'lines':
        return <DataDisplay apiEndpoint="/admin/lines" />;
      case 'rankings':
        return <DataDisplay apiEndpoint="/admin/rankings" />;
      case 'calendar':
        return <CalendarStatus />;
      case 'watchData':
        return <WatchDataPanel />;
      default:
        return <div>Select a tab</div>;
    }
  };

  return (
    <div className={styles.dashboard}>
      <div className={styles.sidebar}>
        <h2 className={styles.dashboardTitle}>Admin Dashboard</h2>
        <button className={`${styles.navButton} ${activeTab === 'users' ? styles.active : ''}`} onClick={() => setActiveTab('users')}>User Management</button>
        <button className={`${styles.navButton} ${activeTab === 'apiStatus' ? styles.active : ''}`} onClick={() => setActiveTab('apiStatus')}>API Status Overview</button>
        <button className={`${styles.navButton} ${activeTab === 'locks' ? styles.active : ''}`} onClick={() => setActiveTab('locks')}>Locks</button>
        <button className={`${styles.navButton} ${activeTab === 'createLock' ? styles.active : ''}`} onClick={() => setActiveTab('createLock')}>Create Manual Lock</button>
        <button className={`${styles.navButton} ${activeTab === 'games' ? styles.active : ''}`} onClick={() => setActiveTab('games')}>Games Data</button>
        <button className={`${styles.navButton} ${activeTab === 'venues' ? styles.active : ''}`} onClick={() => setActiveTab('venues')}>Venues Data</button>
        <button className={`${styles.navButton} ${activeTab === 'lines' ? styles.active : ''}`} onClick={() => setActiveTab('lines')}>Lines Data</button>
        <button className={`${styles.navButton} ${activeTab === 'rankings' ? styles.active : ''}`} onClick={() => setActiveTab('rankings')}>Rankings Data</button>
        <button className={`${styles.navButton} ${activeTab === 'calendar' ? styles.active : ''}`} onClick={() => setActiveTab('calendar')}>Calendar Status</button>
        <button className={`${styles.navButton} ${activeTab === 'watchData' ? styles.active : ''}`} onClick={() => setActiveTab('watchData')}>Watch Data</button>
      </div>
      <div className={styles.content}>
        {error && <p className={styles.errorMessage}>{error}</p>}
        {renderComponent()}
        <VersionFooter />
      </div>
    </div>
  );
}

export default AdminDashboard;
